export default "__VITE_ASSET__BS6eDs04__"